"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTabs = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _getUniqueId = require("../utils/getUniqueId");

var useTabs = function useTabs(_ref) {
  var tabs = _ref.tabs,
      onTabSelect = _ref.onTabSelect,
      defaultTab = _ref.defaultTab;

  var _useState = (0, _react.useState)((0, _getUniqueId.getUniqueId)()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      tabGroupNumber = _useState2[0];

  var tabValues = tabs.map(function (tab) {
    return typeof tab === 'string' ? tab : tab.value;
  });

  var _useState3 = (0, _react.useState)(defaultTab || tabValues[0]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selectedTab = _useState4[0],
      setSelectedTab = _useState4[1];

  var combinedOnTabSelect = function combinedOnTabSelect(value) {
    !!onTabSelect && onTabSelect(value);
    setSelectedTab(value);
  };

  var tabGroup = "TabGroup-".concat(tabGroupNumber);
  return {
    tabBarProps: {
      tabs: tabs,
      selectedTab: selectedTab,
      onTabSelect: combinedOnTabSelect,
      tabGroup: tabGroup
    },
    tabSwitcherProps: {
      selectedTab: selectedTab,
      tabGroup: tabGroup
    }
  };
};

exports.useTabs = useTabs;